// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import SuppliersApi from "../Apis/SuppliersApi";

const SupplierModel = ({disabled = false, onSupplierChange}) => {

    const [Suppliers, setSuppliers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadSupplierClicked, setIsReloadSupplierClicked] = useState(false);
    
    const handleReloadSupplierClick = async () => {
        setIsReloadSupplierClicked(true);

        try {
            setLoading(true);

            let currentPage = 0;
            let allSuppliers = [];
            let totalPages = 1;

            do {
                const response = await SuppliersApi.Listsuppliers(currentPage, 10);

                allSuppliers = [
                    ...allSuppliers,
                    ...(response?.payloadDto || [])
                ];

                totalPages = response?.totalPages || 0;
                currentPage++;

            } while (currentPage < totalPages);

                setSuppliers(allSuppliers);
                setTotalPageNew(totalPages);
                setPage(currentPage);

        } catch (error) {
            console.error("Error fetching suppliers:", error);
        } finally {
            setLoading(false);

            setTimeout(() => {
                setIsReloadSupplierClicked(false);
            }, 1000);
        }
    };

    const fetchAllSuppliers = async () => {
    try {
        setLoading(true);

        let currentPage = 0;
        let allSuppliers = [];
        let totalPages = 1;

        do {
            const response = await SuppliersApi.Listsuppliers(currentPage, 10);
            allSuppliers = [...allSuppliers, ...(response?.payloadDto || [])];
            totalPages = response?.totalPages || 0;
            currentPage++;

        } while (currentPage < totalPages);

        setSuppliers(allSuppliers);
        setTotalPageNew(totalPages);
        setPage(currentPage);

    } catch (error) {
        console.error("Error fetching suppliers:", error);
    } finally {
        setLoading(false);
    }
};

    useEffect(() => {
        fetchAllSuppliers();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="supplierId"
                label="Supplier :"
                className="text-lable col-10"
                rules={[
                    {
                        required: true,
                        message: "Please Select Department.",
                    },
                ]}
            >
                <Select
                    mode="multiple"
                    className="control-Select mb-1"
                    placeholder="Select Supplier Name"
                    disabled={disabled}
                    onChange={(values) => {
                    const selectedSuppliers = Suppliers.filter(item =>
                        values.includes(item.id)
                    );

                    onSupplierChange?.(selectedSuppliers);
                }}
                >
                    {Suppliers.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.supplierName} ({option.institutionDTO?.institutionName})
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadSupplierClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadSupplierClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/suppliers/add-Supplier"} target="_blank">
                        <u>Create New Supplier</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default SupplierModel;
